import cssVars from '../_variables.scss.js';
import sortBy from 'lodash/sortBy';
import pickBy from 'lodash/pickBy';
import toPairs from 'lodash/toPairs';
import mapKeys from 'lodash/mapKeys';
import mapValues from 'lodash/mapValues';

/**
 * A mapping of breakpoint names to width values
 *
 * { "xs": "360px", "sm": "768px", "md": "960px", ... }
 */

var BREAKPOINTS = mapKeys(pickBy(cssVars, function (_varValue, varName) {
  return varName.startsWith('breakpoint-');
}), function (_varValue, varName) {
  return varName.slice('breakpoint-'.length).toLowerCase();
});
/**
 * The breakpoint names sorted in ascending order by breakpoint size
 *
 * ["xs", "sm", "md", "lg", ...]
 *
 * Assumes that all breakpoints are defined in the same unit ("px", "rem", etc)
 */

var SORTED_BREAKPOINT_NAMES = Object.keys(BREAKPOINTS).sort(function (a, b) {
  var breakpointA = parseInt(BREAKPOINTS[a], 10);
  var breakpointB = parseInt(BREAKPOINTS[b], 10);
  return breakpointA - breakpointB;
});
/**
 * The breakpoints where the number of columns change:
 *   { "sm": 8, "md": 12 }
 */

var COLUMN_BREAKPOINTS = mapValues(mapKeys(pickBy(cssVars, function (_varValue, varName) {
  return varName.startsWith('columns-');
}), function (_varValue, varName) {
  return varName.slice('columns-'.length).toLowerCase();
}), function (varValue) {
  return parseInt(varValue, 10);
});
/**
 * The COLUMN_BREAKPOINTS, as an array, sorted by number of columns
 *
 * [["sm", 8], ["md", 12]]
 */

var COLUMN_BREAKPOINT_TUPLES = sortBy(toPairs(COLUMN_BREAKPOINTS), function (tuple) {
  return tuple[1];
});
/**
 * Given a breakpoint name (or `null`, representing the "default" breakpoint)
 *   calculate the expected number of columns
 */

function columnCountFromBreakpoint(breakpointName) {
  var columnCount = parseInt(cssVars.defaultColumns, 10);

  if (breakpointName === null) {
    return columnCount;
  }

  for (var _i = 0, SORTED_BREAKPOINT_NAMES_1 = SORTED_BREAKPOINT_NAMES; _i < SORTED_BREAKPOINT_NAMES_1.length; _i++) {
    var otherBreakpointName = SORTED_BREAKPOINT_NAMES_1[_i];

    if (COLUMN_BREAKPOINTS.hasOwnProperty(otherBreakpointName)) {
      columnCount = COLUMN_BREAKPOINTS[otherBreakpointName];
    }

    if (otherBreakpointName == breakpointName) {
      return columnCount;
    }
  }

  return columnCount;
}

export { BREAKPOINTS, COLUMN_BREAKPOINTS, COLUMN_BREAKPOINT_TUPLES, SORTED_BREAKPOINT_NAMES, columnCountFromBreakpoint };
//# sourceMappingURL=breakpoints.js.map
